module.exports = __webpack_public_path__ + "img/coinpayments.ee1cb09b.svg";